<template>
  <span>{{ text }}</span>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getStateByCode } from '@/class/cargo/model/parameters/CommonState'

export default Vue.extend({
  name: 'AnalysisDuration',
  data() {
    return {
      timer: null,
      timePassing: ''
    }
  },
  computed: {
    text() {
      const { timePassing, params: { value }} = this
      let str = ''
      const s = getStateByCode(SystemConstants.ANALYSIS_STATUS_LIST, value)
      if (s) {
        str = this.$store.getters.language === 'zh' ? s.chineseName : s.englishName
        if (s.code === SystemConstants.ANALYSIS_STATUS_1.code) { // 正在解析
          str = this.$t('SeaExport.UploadCompletedParsing') + timePassing
        }
      }
      return str
    }
  },
  created() {
    const { params: { value }} = this
    if (value === SystemConstants.ANALYSIS_STATUS_1.code) {
      this.setTimePassing()
      this.timer = setInterval(() => {
        this.setTimePassing()
      }, 1000)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    getTime(val) {
      let newVal = String(parseInt(val, 10))
      if (newVal.length < 2) {
        newVal = '0' + newVal
      }
      return newVal
    },
    setTimePassing() {
      const { data: { dateCreated }} = this.params
      const timePassing = moment().diff(moment(dateCreated))
      if (timePassing < 0) {
        return
      }
      const tatalSeconds = this.getTime(timePassing / 1000)
      const hours = parseInt(tatalSeconds / 3600, 10)
      const minutes = this.getTime((tatalSeconds % 3600) / 60)
      const seconds = this.getTime((tatalSeconds % 3600) % 60)
      this.timePassing = `${hours ? hours + this.$t('Pricing.Hour') : ''}${minutes ? minutes + this.$t('CargoMsg.Cargo_Cent') : ''}${seconds ? seconds + this.$t('SeaExport.Second') : ''}`
    }
  }
})
</script>

<style scoped>

</style>
